import { render } from "./banner-null.vue?vue&type=template&id=3c5eebc4&scoped=true"
import script from "./banner-null.vue?vue&type=script&lang=js"
export * from "./banner-null.vue?vue&type=script&lang=js"

import "./banner-null.vue?vue&type=style&index=0&id=3c5eebc4&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5eebc4"]])

export default __exports__